import React from 'react'

const ProductManagement = () => {
  return (
    <div>ProductManagement</div>
  )
}

export default ProductManagement